import { HQSliceActions } from "./hq.store";

export const { setHQAccessToken, logoutHQ } = HQSliceActions;
